import { jsx as _jsx } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { useClientBrand } from "../../hooks/useClientBrand.js";
import { Actions, useAppContext } from "../../stores/index.js";
import Button from "../Button/Button.js";
const ConnectWalletButton = ({ size = "sm", ...props }) => {
    const { dispatch } = useAppContext();
    const { t } = useI18N("wallet");
    const { buttons: { primary }, } = useClientBrand();
    return (_jsx(Button, { ...props, variant: "gradient", size: size, ...primary, onClick: () => Actions.setConnectWalletOpen(true, dispatch), children: t("button.connect") }));
};
export default ConnectWalletButton;
//# sourceMappingURL=ConnectWalletButton.js.map